<style lang="scss" scoped>
  @import '../css/main.scss';

/*  .swiper-button-next {
    background: url('../img/slide-arrow-right.png') no-repeat center top;
    background-size: 100% auto;
  }

  .swiper-button-prev {
    background: url('../img/slide-arrow-left.png') no-repeat center top;
    background-size: 100% auto;
  }*/
  .swiper-button-next {
    background: url('../img/icons8-chevron-right-48.png') no-repeat center top;
    background-size: 100% auto;
  }
  .swiper-button-prev {
    background: url('../img/icons8-chevron-left-48.png') no-repeat center top;
    background-size: 100% auto;
  }
  .company-logo{
    width: 35%;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 20px;
  }
  .company-address{
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 20px;
  }
</style>

<template>
  <div class="urban-asset">
    <urban-header></urban-header>
    <full-page ref="fullpage" :options="options" id="fullpage">
      <section class="page-first section" data-anchor="">
        <h2 class="blind">지도로 아이템보기</h2>
        <div class="main-map-center">
        <SearchEstate :key="componentKey"/>
        </div>
<!--        <div class="item-view">-->
<!--          <span class="fixed-item">지도로 아이템보기<i class="icon"></i></span>-->
<!--        </div>-->
        <div class="main-left-banner" @click="redirectReg">
          <button type="button" @click="redirectReg">
            <div class="banner" role="banner">
              <span class="tit"><strong>신속정확 처리</strong><br>내 매물 등록하기</span>
              <span class="txt">매물 등록하기</span>
            </div>
          </button>
        </div>
        <div class="main-right-banner">
          <swiper ref="bannerSwiper" :options="bannerOptions" v-if="this.getBannerMainList.length !== 0">
            <swiper-slide v-for="(slide, index) in this.getBannerMainList" :key="index">
              <router-link :to="slide.banUrl" v-if="slide.banView === '002'">
                <div class="thumb-img">
                  <img :src="imgUrl + '/' + slide.fileName" :alt="slide.banTitle">
                </div>
              </router-link>
              <a :href="slide.banUrl" :title="slide.banTitle" target="_blank" v-else>
                <!--<span class="item-img" :class="item.banTitle">{{item.fileName}}</span>-->
                <img :src="imgUrl + '/' + slide.fileName" :alt="slide.banTitle">
              </a>
              <!--<div class="thumb-img">
                <img :src="imgUrl + '/' + slide.fileName" :alt="slide.banTitle">
              </div>-->
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
        <div class="main-bottom-button" @click="redirectReg">
        </div>
      </section>
      <section class="page-second section" data-anchor="second-section">
        <div class="urban-container">
          <h2 class="section-tit">추천 아이템</h2>
          <div class="tab-container">
            <ul class="tab-list">
              <li class="list-item" v-for="(tab, index) in this.getEtcCode001List" :key="index">
                <button type="button" class="tab-btn" :class="{active: currentTab === tab.deCode}"
                        @click="[tablClick(tab)]">{{tab.codeNm}}
                </button>
              </li>
            </ul>
            <div class="tab-content" id="tab-contents">
              <p v-if="this.getRcEstatelists.length === 0"
                 style="text-align: center;color: #fff;font-size: 20px;padding-top: 100px;">등록된 매물이 없습니다.</p>
              <swiper ref="mySwiper" :options="swiperOptions" v-else>
                <swiper-slide v-for="(slide, index) in this.getRcEstatelists" :key="index">
                  <router-link :to="{ name: 'ViewEstate', params: { id: slide.idEstate}}">
                    <div class="thumb-img" v-if="typeof slide.images === 'undefined'">
                      <img src="../img/thumbnail-small.jpg" alt="">
                      <!-- <img src="../img/thumb-img-01.png" alt=""> -->
                    </div>
                    <div class="thumb-img" v-else>
                      <img :src="$store.state.common.urlpath + '/uploads/' + slide.images" alt="">
                    </div>
                    <div class="thumb-desc">
                      <span class="desc-area">{{slide.regionEstate2}}</span>
                      <span class="desc-tit">{{slide.descCommand | truncate(40, '...')}}</span>
                      <span class="desc-price">{{slide.price}}</span>
                      <font-awesome-icon icon="plus" class="plus-icon"/>
                    </div>
                  </router-link>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </div>
        </div>
      </section>
      <section class="page-third section" data-anchor="third-section">
        <div class="urban-container">
          <h5 class="section-tit">부동산 관련 전문가(협회 소속된 전문가)</h5>
          <div class="contents">
            <div class="banner" role="banner">
              <span class="txt">안전한 거래 원하시나요?<strong>저희가 추천해드립니다!</strong></span>
            </div>
            <div class="recommend-kind">
              <ul class="kind-list">
                <li class="list-item" v-for="(item, index) in this.getTypeProlists" :key="index">
                  <button type="button" class="item-btn" @click="[popupOpen(item)]">
                    <i class="icon"
                       :style="{backgroundImage: 'url('+require('../img/main/recommend-list-'+item.idTypePro+'.png')+')'}"></i>
                    <span class="tit">{{item.nameTypePro}}</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div class="main-popup-container" v-if="recommendPopup">
            <div class="main-popup">
              <button type="button" @click="popupClose" class="close">
                <b-icon-x></b-icon-x>
              </button>
              <h2 style="text-align: center; padding-bottom: 20px">부동산 관련 전문가(협회 소속된 전문가)</h2>
              <div class="company-logo">
                <img :src="require('@/img/main/recommend-list-'+idTypePro+'.png')">
              </div>
              <div class="company-address">
                <span v-if="recommendItems[0]">{{recommendItems[0]['proAddr']}}</span>
              </div>
              <swiper class="swiper" :options="swiperOptionsComm">
                <swiper-slide v-for="(slide, index) in this.recommendItems" :key="index">
                  <a :href="slide.proUrl" target="_blank">
                    <img :src="imgUrl + '/' + slide.proPicFileNm" style="border: 1px solid #ddd; border-radius: 10px;">
                  </a>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </div>
        </div>
      </section>
      <section class="page-fourth section fp-auto-height" data-anchor="fourth-section">
        <h2 class="blind">Business Support</h2>
        <urban-footer></urban-footer>
      </section>
    </full-page>
  </div>
</template>

<script>
import UrbanHeader from '@/components/UrbanHeader'
import UrbanFooter from '@/components/UrbanFooter'
import SearchEstate from '@/pages/SearchEstate'
import {response} from '@/mixins/response'
import {mapActions, mapGetters} from 'vuex'
import axios from 'axios'

const body = document.getElementsByTagName('body')[0]

export default {
  name: 'Main',
  mixins: [response],
  components: {
    'urban-header': UrbanHeader,
    'urban-footer': UrbanFooter,
    SearchEstate
  },
  data () {
    return {
      type: '',
      recommendPopup: false,
      slickOptions: {
        slidesToShow: 3
      },
      options: {
        licenseKey: 'EDC34384-B27745AF-AFD1EAF4-D6A679FF',
        anchors: ['first-section', 'second-section', 'third-section', 'fourth-section'],
        scrollingSpeed: 1000,
        slidesNavigation: true,
        navigation: true,
        navigationTooltips: ['홈', '추천매물', '추천 법무사&#38;중개인', '푸터'],
        autoScrolling: true,
        scrollOverflow: true,
        // for first page no scroll
        normalScrollElements: '.page-first',
        css3: true,
        fitToSection: false
      },
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 50,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1500: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      },
      swiperOptionsComm: {
        slidesPerView: 5,
        spaceBetween: 10,
        centeredSlides: false,
        /*        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        }, */
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      bannerOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      currentTab: '001',
      recommendItems: [],
      idTypePro: '',
      nameTypePro: '',
      imgUrl: this.$store.state.common.urlpath,
      componentKey: 0
      /* bannerSlide: [
                {tit: '땡처리부동산닷컴 OPEN 기념', label: '3개월', txt: '3개월 동안 매물 자유등록', imgSrc: 'src/img/thumb-img-01.png'},
                {tit: '땡처리부동산닷컴 OPEN 기념', label: '3개월', txt: '3개월 동안 매물 자유등록', imgSrc: 'src/img/thumb-img-01.png'},
                {tit: '땡처리부동산닷컴 OPEN 기념', label: '3개월', txt: '3개월 동안 매물 자유등록', imgSrc: 'src/img/thumb-img-01.png'}
              ] */
    }
  },
  created () {
    this.setInit()
    this.$store.dispatch('apiEtcCodelists', {'Code': '001', 'DeCode': ''})
    this.$store.dispatch('apiRcEstatelists', {'type': '001', 'method': 'GET'})
    this.$store.dispatch('apiBannerViewList', {'bannerType': '001'})
  },
  mounted () {
    this.componentKey += 1
  },
  methods: {
    ...mapActions({
      setInit: 'apiTypeProlists'
    }),
    popupOpen (item) {
      this.idTypePro = item['idTypePro']
      this.nameTypePro = item['nameTypePro']
      this.recommendItems = []
      this.setProlist()
      body.classList.add('overflow')
      this.recommendPopup = true
    },
    popupClose () {
      body.classList.remove('overflow')
      this.recommendPopup = false
    },
    tablClick (tab) {
      this.$store.dispatch('apiRcEstatelists', {'type': tab.deCode, 'method': 'GET'})
      this.currentTab = tab.deCode
    },
    redirectReg () {
      if (sessionStorage.getItem('token') === null) {
        alert('해당 서비스는 로그인 이후 이용가능합니다.')
        this.$router.push('/Login')
      } else {
        this.$router.push('/Registration')
      }
    },
    fullpageScrollStop () {
      this.$refs.fullpage.api.setAutoScrolling(false)
      body.classList.add('overflow')
    },
    fullpageScrollStart () {
      this.$refs.fullpage.api.setAutoScrolling(true)
      body.classList.remove('overflow')
    },
    setProlist () {
      const payload = {
        'searchProType': this.idTypePro,
        'searchProName': '',
        'searchSido': '',
        'searchGugun': ''
      }
      axios.post('/api/common/getProList', payload)
        .then((response) => {
          if (response.data.length > 0) {
            this.recommendItems = response.data
          }
        }).catch((error) => {
          console.error(error)
        })
    }
  },
  computed: {
    ...mapGetters({
      getTypeProlists: 'getTypeProlists',
      getRcEstatelists: 'getRcEstatelists',
      getEtcCode001List: 'getEtcCode001List',
      getBannerMainList: 'getBannerMainList'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Main.vue